import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const SalePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    // Check if user has already seen the popup in this session
    const hasSeenPopup = sessionStorage.getItem('salePopupSeen');
    
    if (!hasSeenPopup) {
      // Show popup after 2 seconds
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      sessionStorage.setItem('salePopupSeen', 'true');
    }, 300);
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className={`fixed inset-0 bg-black transition-opacity duration-300 z-50 ${
          isClosing ? 'opacity-0' : 'opacity-50'
        }`}
        onClick={handleClose}
      />

      {/* Popup */}
      <div className="fixed inset-0 flex items-center justify-center z-50 p-4 pointer-events-none">
        <div 
          className={`bg-white rounded-2xl shadow-2xl max-w-md w-full relative transform transition-all duration-500 pointer-events-auto ${
            isClosing ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
          }`}
        >
          {/* Close Button */}
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Close popup"
          >
            <X size={24} />
          </button>

          {/* Content */}
          <div className="p-8 text-center">
            {/* Icon/Emoji */}
            <div className="text-6xl mb-4">🎁</div>

            {/* Title */}
            <h2 className="text-3xl font-bold text-gray-900 mb-3">
              Special Offer!
            </h2>

            {/* Discount */}
            <div className="bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-lg py-4 px-6 mb-4">
              <p className="text-5xl font-bold mb-2">20% OFF</p>
              <p className="text-lg">Any Course or Bundle</p>
            </div>

            {/* Promo Code */}
            <div className="bg-gray-100 rounded-lg py-3 px-4 mb-4">
              <p className="text-sm text-gray-600 mb-1">Use code at checkout:</p>
              <p className="text-2xl font-bold text-purple-600 tracking-wider">OFFER20</p>
            </div>

            {/* Description */}
            <p className="text-gray-600 mb-6">
              Limited time! Start your cloud journey today.
            </p>

            {/* CTA Button */}
            <button
              onClick={handleClose}
              className="w-full bg-gradient-to-r from-purple-600 to-blue-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:shadow-lg transition-all duration-200"
            >
              Start Learning Now
            </button>
          </div>
        </div>
      </div>

    </>
  );
};

export default SalePopup;

